import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const sectionStyles: SxProps<Theme> = {
    mt: 3,
};

export const cardStyles: SxProps<Theme> = {
    p: 3,
    mb: 3,
};

export const cardTitleStyles: SxProps<Theme> = {
    fontWeight: 600,
    mb: 0.5,
};

export const cardHintStyles: SxProps<Theme> = {
    color: 'text.secondary',
    mb: 2.5,
};

/**
 * The time field, capped rather than full width.
 *
 * A time input is five characters wide whatever the container is, and stretching it across a
 * desktop card makes it read as a text field somebody forgot to fill in.
 */
export const sendTimeFieldStyles: SxProps<Theme> = {
    maxWidth: 200,
};

export const channelListStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    // Wider than the checkbox default so the "not yet available" captions under the disabled
    // rows do not run into the label of the row below.
    gap: 0.5,
};

export const channelHintStyles: SxProps<Theme> = {
    color: 'text.secondary',
    // Lines up under the label rather than under the checkbox, which is 42px of tap target
    // on a coarse pointer and would leave the caption looking unattached.
    ml: 4,
    mt: -0.5,
    mb: 1,
};

export const actionsStyles: SxProps<Theme> = {
    display: 'flex',
    gap: 2,
    flexWrap: 'wrap',
};

/**
 * The line that sits beside a disabled Save and says why it is disabled. Modelled on the
 * count-of-problems hint the About and Our Services editors already show.
 */
export const blockedSaveStyles: SxProps<Theme> = {
    color: 'error.main',
    alignSelf: 'center',
    mr: 2,
};
